import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, Link } from "react-router-dom";
function AdminBillGenerate() {
  const { network } = useParams();
  const [activeCount, setActiveCount] = useState(0);
  const [deactiveCount, setDeactiveCount] = useState(0);
 const navigate = useNavigate();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("https://node.cabletvpay.in/getBillData", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ network })
        });
        const data = await response.json();
        setActiveCount(data.activeCount);
        setDeactiveCount(data.deactiveCount);
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("Error fetching bill data");
      }
    };
    fetchData();
  }, [network]);

  // ✅ Handle bill generation
const handleGenerateBill = async () => {
  try {
    const response = await fetch("https://node.cabletvpay.in/billGenerate", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ user: network,network }) // ✅ FIX
    });

    const result = await response.json();

    if (response.ok && result.success) {
      toast.success(`Bill generated successfully for ${network}`);
      setTimeout(() => {
        navigate("/adminOperator");
      }, 1500);
    } else {
      toast.error(result.message || "Failed to generate bill");
    }
  } catch (error) {
    console.error("Error generating bill:", error);
    toast.error("Something went wrong while generating bill");
  }
};


  return (
    <div className="content-wrapper">
      <div className="content-header pt-1">
        <div className="mt-3">
          <div className="fs-4 valuesDec fw-bold">{network} Bill Generate Details</div>
        </div>
        <hr />

        <div className="card elevation-5 mt-3 mt-lg-5" style={{ backgroundColor: "#cccccc" }}>
          <div className="card-header filterBtn">
            <div className="row">
              <div className="col-lg-4">
                <div className="text-left mb-lg-0 w-50">
                  <h4 className="pb-0 mb-0 mt-1 text-navy">Bill Generate Details</h4>
                </div>
              </div>
            </div>
          </div>

          <div className="card-body p-0">
            <table id="myTable" className="table table-bordered table-responsive-lg">
              <thead className="bg-gradient-navy">
                <tr>
                  <th>Sl_No</th>
                  <th>Total Customer</th>
                  <th>Active Customer</th>
                  <th>Deactive Customers</th>
                  <th>Sms Used</th>
                  <th>Generate Bill</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>{activeCount + deactiveCount}</td>
                  <td>{activeCount}</td>
                  <td>{deactiveCount}</td>
                  <td>0</td>
                  <td>
                    <div className="d-flex justify-content-center">
                      <button 
                        className="btn btn-info"
                        onClick={handleGenerateBill}
                      >
                        Generate
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Toast Container for notifications */}
        <ToastContainer position="top-right" autoClose={3000} />
      </div>
    </div>
  );
}

export default AdminBillGenerate;
